function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28.394,
  height: 28.394,
  transform: "translate(409.892 366.245)",
  fill: "#009fda"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "i"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g",
  clipPath: "url(#i)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-408.892 -365.245)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M424.088,394.64a14.2,14.2,0,1,1,14.2-14.2A14.214,14.214,0,0,1,424.088,394.64Zm0-27a12.8,12.8,0,1,0,12.8,12.8A12.811,12.811,0,0,0,424.088,367.645Zm-.07,23.138a2.628,2.628,0,1,1,2.628-2.628A2.631,2.631,0,0,1,424.018,390.783Zm0-3.856a1.228,1.228,0,1,0,1.228,1.228A1.229,1.229,0,0,0,424.018,386.927Zm.643-1.928h-1.928a1.281,1.281,0,0,1-1.273-1.343v-1.285c0-1.665,1.764-3.2,3.051-4.324.321-.28.612-.532.829-.75a1.306,1.306,0,0,0,.377-1.052,1.344,1.344,0,0,0-2.675-.033,1.5,1.5,0,0,1-1.6,1.717h-1.285a1.95,1.95,0,0,1-1.437-.518,1.736,1.736,0,0,1-.478-1.275,6.121,6.121,0,0,1,9.494-4.889,6.238,6.238,0,0,1,2.76,4.656,5.894,5.894,0,0,1-1.787,4.79,11.594,11.594,0,0,1-.988.8c-.516.388-1.587,1.2-1.652,1.539v.628A1.4,1.4,0,0,1,424.661,385Zm-1.8-1.4h1.8l.013-.586c0-.977,1.123-1.823,2.209-2.641.345-.261.671-.507.864-.691a4.5,4.5,0,0,0,1.359-3.659,4.846,4.846,0,0,0-2.147-3.614,4.721,4.721,0,0,0-7.312,3.759.42.42,0,0,0,.07.255.693.693,0,0,0,.445.107h1.285a.875.875,0,0,0,.193-.016,3.565,3.565,0,0,1,.006-.374,2.743,2.743,0,0,1,5.465-.024,2.707,2.707,0,0,1-.78,2.172c-.237.236-.552.512-.9.816-1.024.892-2.571,2.24-2.571,3.268Z",
  fill: "#009fda"
}))));

var SvgWhatIsPhysio30Px = function SvgWhatIsPhysio30Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatIsPhysio30Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WHAT_IS_PHYSIO_30px.4f8f05bd.svg";
export { ForwardRef as ReactComponent };